<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-27 10:37:42
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:31:32
--> 
<template>
  <mrc_ess_skeleton_loader
    :loading="$store.state.uuid ? skeletonloading : false"
  >
    <v-card>
      <v-card-text>
        <!--调岗人员-->
        <v-row>
          <v-col cols="12" sm="6">
            <mrc_ess_staffInfo
              v-model="list.apply_staff_uuid"
              :background-color="disabled ? '' : '#f5f5f5'"
              job_post_name="job_post_uuid"
              job_grade_name="job_post_grade_uuid"
              client_name="client_uuid"
              org_level_all="org_level_uuid"
              dept_name="dept_uuid"
              :error-messages="
                $errors('list', 'apply_staff_uuid', requiredRule)
              "
              :dropDownList="dropDownList"
              :readonly="disabled"
              :disabled="Boolean($store.state.uuid)"
              :multiple="false"
              @changeStaffList="changeStaffList"
              :label="this.$t('label_A_departing_employee') + '*'"
            >
            </mrc_ess_staffInfo>
          </v-col>
          <v-col cols="12" sm="6">
            <!-- afterDate -->
            <mrc_ess_datePicker
              @getTime="paramsChange"
              :errMsg="$errors('list', 'change_effective', requiredRule)"
              :disabled="disabled"
              :label="$t('label_The_effective_date') + '*'"
              v-model="list.change_effective"
            >
            </mrc_ess_datePicker>
          </v-col>
          <v-col cols="12">
            <v-card v-if="list.apply_staff_uuid" flat outlined rounded="lg">
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    <mrc_ess_input
                      :label="$t('label_The_original_company') + '*'"
                      :value="INT(viewList.org_level_uuid)"
                      :background-color="disabled ? '' : '#f5f5f5'"
                      :readonly="disabled"
                      :disabled="true"
                    >
                    </mrc_ess_input>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <!-- <mrc_ess_input
                      :label="$t('label_The_original_department') + '*'"
                      :value="INT(viewList.dept_uuid)"
                      :background-color="disabled ? '' : '#f5f5f5'"
                      :readonly="disabled"
                      :disabled="true"
                    >
                    </mrc_ess_input> -->
                    <mrc_ess_autoComplete
                      :label="$t('label_The_original_department') + '*'"
                      :readonly="true"
                      :disabled="true"
                      :background-color="disabled ? '' : '#f5f5f5'"
                      deptView
                      v-model="viewList.dept_uuid_save_value"
                      :prompt_name="deptuuid"
                    >
                    </mrc_ess_autoComplete>
                  </v-col>
                  <v-col cols="12">
                    <mrc_ess_input
                      :label="$t('label_The_original_position') + '*'"
                      :value="INT(viewList.job_post_uuid)"
                      :background-color="disabled ? '' : '#f5f5f5'"
                      :readonly="disabled"
                      :disabled="true"
                    >
                    </mrc_ess_input>
                  </v-col>
                  <v-col cols="12">
                    <mrc_ess_input
                      :label="$t('label_Former_boss') + '*'"
                      :value="INT(viewList.direct_leader_code)"
                      :background-color="disabled ? '' : '#f5f5f5'"
                      :readonly="disabled"
                      :disabled="true"
                    >
                    </mrc_ess_input>
                  </v-col>
                  <v-col cols="12">
                    <mrc_ess_input
                      :label="$t('label_The_original_role') + '*'"
                      :value="INT(viewList.role_uuids)"
                      :background-color="disabled ? '' : '#f5f5f5'"
                      :readonly="disabled"
                      :disabled="true"
                    >
                    </mrc_ess_input>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-chip
              rounded
              color="grey"
              small
              class="white--text"
              v-if="list.result_status == 0"
              >{{ $t("label_Unchanged") }}</v-chip
            >
            <v-chip
              rounded
              color="#18A874"
              small
              class="white--text"
              v-if="list.result_status == 1"
              >{{ $t("label_Complete") }}</v-chip
            >
            <v-chip
              rounded
              color="#18A874"
              small
              class="white--text"
              v-if="list.result_status == 2"
              >{{ $t("label_The_task_processing_is_complete") }}</v-chip
            >
          </v-col>
          <v-col cols="12">
            <mrc_ess_dictName
              v-model="list.termination_reason"
              :disabled="disabled"
              :errMsg="$errors('list', 'termination_reason', requiredRule)"
              :rules="false"
              :label="$t('label_Reason_for_separation') + '*'"
              dict_name="reason_for_resignation"
            >
            </mrc_ess_dictName>
          </v-col>
          <v-col cols="12">
            <mrc_ess_multiText
              :label="$t('label_note')"
              noRequired
              :error-messages="$errors('list', 'remark', nocharacter)"
              :isNational="judegNational('remark')"
              v-model="list.remark"
              :readonly="disabled"
            >
            </mrc_ess_multiText>
          </v-col>
        </v-row>
      </v-card-text>
      <mrc_ess_submitBtn
        @success="success"
        @cancel="cancel"
        :loading="btnIsLoading"
        v-if="!disabled"
      ></mrc_ess_submitBtn>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script>
import {
  getStaffLeaveList,
  addStaffLeave,
  updateStaffLeave,
  deleteStaffLeave,
  detailStaffLeave,
  getallList,
} from "@/service/api/staffmsg.js";
import { getStaffListForFilter } from "@/service/api/autoComplete.js";
import {
  required,
  maxLength,
  between,
  email,
  url,
} from "vuelidate/lib/validators";
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dropDownList: [],
      skeletonloading: true,
      list: {},
      btnIsLoading: false,
      viewList: {},
    };
  },
  computed: {
    StaffDimission() {
      // if (!this.$store.state.uuid) {
      //   return { prompt_name: 'StaffDimission', org_level_uuid: this.$store.state.currentCompany }
      // }
      // else {
      //   return { prompt_name: 'StaffDimission-updateInfo&' + list.apply_staff_uuid, org_level_uuid: this.$store.state.currentCompany, }
      // }
    },
    deptuuid() {
      //部门参照查询字段
      return {
        prompt_name: "levelUuid_deptUuid",
        org_level_uuid: this.company_uuid,
      };
    },
    company_uuid() {
      //当前选中公司
      return this.$store.state.currentCompany;
    },
    company_Name() {
      //当前选中公司名字
      const items = this.$store.state.topcompanylist.filter(
        (item) => item.uuid == this.$store.state.currentCompany
      );
      return items[0].org_level_name;
    },
    job_post_uuid() {
      //岗位查询
      return {
        prompt_name: "level-dept-post",
        dept_uuid: this.viewList.dept_uuid,
      };
    },
    superior() {
      //上司高级参照
      return {
        prompt_name: "boss",
        org_level_uuid: this.company_uuid,
        staff_uuid: this.$store.state.uuid,
      };
    },
    spica() {
      //角色高级参照
      return { prompt_name: "level-role", org_level_uuid: this.company_uuid };
    },
  },
  created() {},
  watch: {},
  async mounted() {
    this.national("mrbase_sys_staff_termination");
    if (this.$store.state.uuid) {
      await this.getDetail();
      getallList({
        org_level_uuid: this.$store.state.currentCompany,
        filter: "StaffDimission-update&" + this.list.apply_staff_uuid,
      }).then((res) => {
        if (res.code == 200) {
          this.dropDownList = res.data;
        }
      });
    } else {
      getallList({
        org_level_uuid: this.$store.state.currentCompany,
        filter: "StaffDimission-add",
      }).then((res) => {
        if (res.code == 200) {
          this.dropDownList = res.data;
        }
      });
      // console.log(this.dropDownList);
      this.skeletonloading = false;
    }
  },
  methods: {
    changeStaffList(val) {
      this.viewList = val;
      // findBossRole({ staff_uuid: val.value_field }).then(res => {
      //   if (res.code == 200) {
      //     console.log(res);
      //     this.viewList = { ...this.viewList, direct_leader_code: res.data.direct_leader_code, role_uuids: res.data.role_uuids }
      //   }
      // })
    },
    paramsChange() {},
    async getDetail() {
      this.skeletonloading = true;
      const res = await detailStaffLeave({ uuid: this.$store.state.uuid });
      if (res.code == 200) {
        this.list = res.data;
      } else {
      }
      this.skeletonloading = false;
    },
    async success() {
      this.$v.list.$touch();
      if (this.$v.list.$error) return;
      if (this.$store.state.uuid) {
        updateStaffLeave(this.$deletefield(null, this.list)).then(
          async (res) => {
            if (res.code == 200) {
              this.$Message({
                text: this.$t("message_The_operation_was_successful"),
              });
              await this.getDetail();
              this.$emit("changeReadonly");
            }
          }
        );
      } else {
        addStaffLeave(this.list).then((res) => {
          if (res.code == 200) {
            this.$Message({ text: this.$t("message_added_successfully") });
            this.$router.push({ name: "staffLeave" });
          }
        });
      }
    },
    async cancel() {
      if (this.$store.state.uuid) {
        await this.getDetail();
        this.$emit("changeReadonly");
      } else {
        this.$myConfirm({
          content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
        })
          .then((res) => {
            this.$router.push({
              name: "staffLeave",
            });
          })
          .catch((err) => {});
      }
    },
  },
  validations: {
    list: {
      change_effective: {
        required,
      },
      termination_reason: {
        required,
      },
      apply_staff_uuid: {
        required,
      },
      remark: {
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
    },
  },
};
</script>

<style scoped>
</style>

